import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'icon-trophy',
  templateUrl: './icon-trophy.component.html',
  styleUrls: ['./icon-trophy.component.scss'],
})
export class IconTrophyComponent  implements OnInit {
  @Input() size :number = 20;
  constructor() { }

  ngOnInit() {}

}
